/**
 * Content with Slider block — slick carousel + shared lightbox.
 *
 * Each block instance has its own pair of slick sliders: a "main" with
 * fade transitions + arrows, and a "thumbs" strip below where clicking
 * a thumb advances the main. Clicking the active main image hands the
 * full URL list off to the shared singleton lightbox in `_lightbox.js`
 * (window.ckLightbox).
 */

jQuery(function ($) {
    $('.ck-content-slider').each(function () {
        const $block  = $(this);
        const $main   = $block.find('[data-ck-cs-main]');
        const $thumbs = $block.find('[data-ck-cs-thumbs]');

        if ( ! $main.length || $main.hasClass( 'slick-initialized' ) ) return;

        const prevArrow = '<button type="button" class="ck-content-slider__arrow ck-content-slider__arrow--prev" aria-label="Previous slide">' +
            '<svg width="14" height="24" viewBox="0 0 14 24" fill="none" aria-hidden="true"><path d="M12 2L2 12l10 10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>';

        const nextArrow = '<button type="button" class="ck-content-slider__arrow ck-content-slider__arrow--next" aria-label="Next slide">' +
            '<svg width="14" height="24" viewBox="0 0 14 24" fill="none" aria-hidden="true"><path d="M2 2l10 10L2 22" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>';

        const hasThumbs = $thumbs.length > 0;

        $main.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            speed: 350,
            arrows: true,
            dots: false,
            infinite: true,
            adaptiveHeight: false,
            prevArrow,
            nextArrow,
            asNavFor: hasThumbs ? $thumbs.get(0) : null,
        });

        if ( hasThumbs ) {
            $thumbs.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: $main.get(0),
                focusOnSelect: true,
                arrows: false,
                dots: false,
                infinite: false,
                responsive: [
                    { breakpoint: 900, settings: { slidesToShow: 4 } },
                    { breakpoint: 600, settings: { slidesToShow: 3 } },
                ],
            });

            // asNavFor doesn't reliably propagate the wrap-around jump
            // when the main has infinite:true and the thumbs have
            // infinite:false. Force the thumbs back to position 0 when
            // the main loops to the first slide, and to the last index
            // when looping the other way.
            $main.on( 'afterChange', function ( e, slick, currentSlide ) {
                $thumbs.slick( 'slickGoTo', currentSlide );
            } );
        }

        // Lightbox trigger: click the currently active main slide image.
        $main.on( 'click', '.slick-current img', function () {
            const urls = $main.find( '.slick-slide:not(.slick-cloned) img' )
                .map( function () { return $(this).attr('data-ck-cs-full') || $(this).attr('src'); } )
                .get();
            const startIndex = $main.slick( 'slickCurrentSlide' );
            if ( window.ckLightbox ) {
                window.ckLightbox.open( urls, startIndex );
            }
        } );
    });
});